import { render, staticRenderFns } from "./MarketplaceCardContentNew.vue?vue&type=template&id=19d375fb&scoped=true"
import script from "./MarketplaceCardContentNew.vue?vue&type=script&lang=js"
export * from "./MarketplaceCardContentNew.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceCardContentNew.vue?vue&type=style&index=0&id=19d375fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d375fb",
  null
  
)

export default component.exports